// Clé unique par application (change-la si tu veux isoler par user)
const KEY = "amen_wishlist_v1";

// Lis l'état courant
function read() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

// Écrit l'état
function write(rows) {
  localStorage.setItem(KEY, JSON.stringify(rows));
}

// Ajoute/maj un article minimal (codArt = identifiant canonique)
export function add(item) {
  if (!item || !item.codArt) return;
  const rows = read();
  const i = rows.findIndex(r => String(r.codArt) === String(item.codArt));
  const payload = {
    codArt: item.codArt,
    name: item.name || item.lib || item.LibArt || "Article",
    price: typeof item.price === "number" ? item.price : (item.PrixTTC ?? null),
    image: item.image || item.img || null,
    rawItem: item.rawItem || null,

    // route de détail (ajuste si besoin)
    link: item.link || `/produits/${encodeURIComponent(item.codArt)}`
  };
  if (i >= 0) rows[i] = { ...rows[i], ...payload };
  else rows.push(payload);
  write(rows);
}

// Supprime par code
export function remove(codArt) {
  const rows = read().filter(r => String(r.codArt) !== String(codArt));
  write(rows);
}

// Liste complète
export function list() {
  return read();
}

// Test présence
export function has(codArt) {
  return read().some(r => String(r.codArt) === String(codArt));
}

// Toggle (retourne nouvel état booléen)
export function toggle(item) {
  if (!item || !item.codArt) return false;
  if (has(item.codArt)) {
    remove(item.codArt);
    return false;
  } else {
    add(item);
    return true;
  }
}
